import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import { t } from '~/helpers';

import LimpezaPitStop from './form';

const formRef = createRef();

class Limpeza extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      params: {},
      show: false,
      gravando: false,
    };
  }

  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  async handleCloseModal() {
    await this.setState({ open: false, gravando: false });
    this.props.close();
  }

  async hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
      gravando: false,
    }));
    this.props.close();
  }

  async handlesub() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
    await formRef.current.submitForm();
  }

  async submeteForm(event) {
    this.setState((prevState) => ({
      ...prevState,
      gravando: true,
    }));
    formRef.current.submitForm(event);
  }

  async finalizaGravacao() {
    this.setState((prevState) => ({
      ...prevState,
      gravando: false,
    }));
  }

  render() {
    const { open, params } = this.state;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 600}
      >
        <DialogTitle>
          <Typography variant="h6">
            {t('s.cadastro.pitstop.limpeza')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <LimpezaPitStop
            data={params}
            reference={formRef}
            close={() => {
              this.handleCloseModal();
              this.props.update(params);
            }}
            cancelarAcao={() => this.hancleCancelarAcao()}
            finalizaGravacao={() => this.finalizaGravacao()}
          />
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={(event) => this.submeteForm(event)}
            disabled={this.state.gravando}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>
          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(Limpeza);
